import { Form, Formik } from 'formik';
import { Link } from 'react-router-dom';
import { Button, Container, Grid, Header } from 'semantic-ui-react';
import styled from 'styled-components';
import * as Yup from 'yup';
import PasswordInput from '../../app/common/form/PasswordInput';
import { useStore } from '../../app/stores/store';

const StyledContainer = styled.div`
        padding: ${props => props.theme.padding.featureContainer};
`;

const StyledCardContainer = styled(Container)`
    background-color: #fff;
    padding: 2em;
    border-radius: 16px;
    box-shadow: 0px 3px 6px rgb(21 146 255 / 16%);
    
    @media (max-width: 768px) {
        padding: 1rem;
    }
`;

const StyledButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    @media (max-width: 768px) {
        flex-direction: column;
        width: 100%;

        button {
            width: 100%;
            margin: 5px 0 !important;
        }
    }
`;

const ChangePasswordPage = () => {
    const { userStore } = useStore();

    const validationSchema = Yup.object({
        password: Yup.string()
            .required('New Password field is required')
            .min(8, 'New Password is too short - should be 8 chars minimum.')
            .matches(/^(?=.*\d)(?=.*[a-zA-Z]).+$/, 'New Password should be a combination of alphanumeric. A special character is optional')
        ,
        confirmPassword: Yup.string()
            .required('Confirm Password field is required')
            .test('passwords-match', 'Passwords must match', function (value) {
                return this.parent.password === value
            })
    });

    return (
        <StyledContainer>
            <StyledCardContainer fluid>
                <Formik
                    initialValues={{
                        oldPassword: '',
                        password: '',
                        confirmPassword: '',
                    }}
                    onSubmit={(values) => userStore.changePassword(values)}
                    validationSchema={validationSchema}
                >
                    {({ handleSubmit, isSubmitting }) => (
                        <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                            <Grid stackable>
                                <Grid.Row columns={3}>
                                    <Grid.Column mobile={16} tablet={3} computer={3}>
                                        <Header as='h3'>Change Password</Header>
                                    </Grid.Column>
                                    <Grid.Column mobile={16} tablet={9} computer={9}>
                                        <PasswordInput 
                                            name='oldPassword' 
                                            placeholder='Old Password' 
                                            label='Old Password' 
                                        />
                                        <Grid stackable columns={2}>
                                            <Grid.Column>
                                                <PasswordInput 
                                                    name='password' 
                                                    placeholder='New Password' 
                                                    label='New Password' 
                                                />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <PasswordInput 
                                                    name='confirmPassword' 
                                                    placeholder='Confirm Password' 
                                                    label='Confirm Password' 
                                                />
                                            </Grid.Column>
                                        </Grid>
                                    </Grid.Column>
                                    <Grid.Column mobile={16} tablet={4} computer={4} />
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column textAlign='right'>
                                        <StyledButtonContainer>
                                            <Button
                                                loading={isSubmitting}
                                                color='blue'
                                                content='Save'
                                                type='submit'
                                                style={{
                                                    backgroundColor: '#1592ff',
                                                    borderRadius: '8px'
                                                }}
                                            />
                                            <Button 
                                                type='button' 
                                                basic 
                                                as={Link} 
                                                to='/'
                                                content='Cancel'
                                            />
                                        </StyledButtonContainer>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </StyledCardContainer>
        </StyledContainer>
    )
}

export default ChangePasswordPage;
